<template>
  <div class="row">
    <div class="col-12">
      <!-- Botón Nuevo -->
      <div class="new-button-div">
        <router-link :to="{ name: 'Nuevo rol empresarial' }" class="col-2">
            <n-button type="primary" round>
              <i slot="label" class="now-ui-icons ui-1_simple-add"></i>
              {{ $t("app.buttons.new") }}
            </n-button>
          </router-link>
      </div>
      <card card-body-classes="table-full-width" no-footer-line>
        <div>
          <div
            class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
          >
            <h4 class="card-title text-purple">
              {{ $t("app.modules.corporate_roles.title") }}
            </h4>
            <fg-input>
              <el-input
                type="search"
                class="mb-3"
                clearable
                prefix-icon="el-icon-search "
                style="width: 300px"
                :placeholder="$t('app.general.search')"
                v-model="searchQuery"
                aria-controls="datatables"
              >
              </el-input>
            </fg-input>
          </div>
          <el-table stripe style="width: 100%" :data="queriedData">
            <el-table-column
              :label="$t('app.modules.corporate_roles.headers.name')"
              sortable
            >
              <template slot-scope="scope">
                {{ scope.row.nombre }}
              </template>
            </el-table-column>
            <el-table-column
              :label="$t('app.modules.corporate_roles.headers.create_date')"
              sortable
            >
              <template slot-scope="scope">
                {{ scope.row.concurrencyStamp }}
              </template>
            </el-table-column>
            <el-table-column
              :label="$t('app.modules.corporate_roles.headers.status')"
              sortable
            >
              <template slot-scope="scope">
                {{
                  scope.row.active
                    ? $t("app.general.active")
                    : $t("app.general.inactive")
                }}
              </template>
            </el-table-column>
             <el-table-column
              :min-width="200"
              fixed="right"
            >
              <div slot-scope="props" class="table-actions dropdown">
                <el-popover
                  placement="bottom"
                  width="250"
                  trigger="click"
                  :ref="'refOption' + props.$index"
                >
                  <div class="row">
                    <div class="col-12 options">
                      <n-button
                        @click.native="
                          openItemEdit(
                            props.$index,
                            props.row,
                            'refOption' + props.$index
                          )
                        "
                        type="primary"
                        class="options-button"
                        size="sm"
                        round
                      >
                        {{ $t("app.modules.corporate_roles.edit_corporate_rol.title") }}
                      </n-button>
                    </div>
                  </div>
                  <n-button
                    slot="reference"
                    size="sm"
                    icon
                    class="button-options-table"
                  >
                    <i class="fa fa-ellipsis-v" style="color:black;"></i>
                  </n-button>
                </el-popover>
              </div>
            </el-table-column>
          </el-table>
        </div>
         <div
            slot="footer"
            class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
          >
            <div class="">
              <p class="card-category">
                {{ $t("app.pagination.showing") }} {{ from + 1 }}
                {{ $t("app.pagination.of") }} {{ to }}
                {{ $t("app.pagination.of") }} {{ total }}
                {{ $t("app.pagination.records") }}
              </p>
            </div>

            <n-pagination
              class="pagination-no-border"
              v-model="pagination.currentPage"
              :per-page="pagination.perPage"
              :total="total"
            >
            </n-pagination>
          </div>
      </card>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  computed: {
    queriedData() {
      let result = this.tableData;
      result =
        this.searchQuery.length > 0
          ? result.filter(p => p.nombre.toLowerCase().includes(this.searchQuery.toLowerCase()))
          : result;
      return result.slice(this.from, this.to);
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      return this.searchedData.length > 0
        ? this.searchedData.length
        : this.tableData.length;
    }
  },
  data() {
    return {
      searchQuery: "",
      fuseSearch: null,
      tableData: [],
      searchedData: [],
      pagination: {
        perPage: 5,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50],
        total: 0
      }
    };
  },
  methods: {
    async initRolesEmpresariales() {
      this.$swal.fire({
        title: this.$t("app.promps.wait"),
        html:
          '<div class="spinner-border text-primary" style="width: 3rem; height: 3rem;" role="status"><span class="sr-only">Loading...</span></div>',
        showConfirmButton: false
      });

      await this.getItems();

      this.$swal.close();
    },
    async getItems() {
      var payload = {
        id: 0,
        claveIdioma: this.$store.state.lang,
        usuario: 0
      };
      await this.$http
        .post(route("Roles/rolesVista"), payload)
        .then(
          async response => {
            if (response.body.code === 200) {
              this.tableData = response.body.roles.filter(r => r.externo);
            } else {
              this.notifyMessage("danger", this.$t("app.promps.error"));
            }
          },
          error => {
            console.log(error);
            this.notifyMessage("danger", this.$t("app.promps.error"));
          }
        )
        .finally(() => {});
    },
    openItemEdit(index, row, ref) {
      this.$router.push({ name: 'Editar rol empresarial', params: row })
      this.$refs[ref].doClose();
    }
  },
  mounted() {
    this.initRolesEmpresariales();

    EventBus.$on("reload-perfiles-empresariales", () => {
      this.initRolesEmpresariales();
    });
  }
};
</script>
